export default {
  init() {
    /**
     * Map and Articles page scripts
     * @author  Javier Colmenárez
     * 1. Rental stores carousel
     */
    this.initSlick();

    jQuery(window).on('resize', () => {
      jQuery('.RentalStores-resultsList').slick('resize');
    });

    jQuery('.RentalStores-carouselNavArrow').on('click', () => {
      jQuery('.RentalStores-resultsList').slick('slickNext');
    });
    /**
     * 2. Activating a rental store item from the list upon click
     */
    // jQuery('.js-rental-stores').on('click', evt => {
    //   const cssClass = 'RentalStores-resultItem--active';
    //   jQuery('.js-rental-stores').removeClass(cssClass);
    //   jQuery(evt.currentTarget).addClass(cssClass);
    // });
    /**
     * 3. Overlay showing the search form over the rental stores list and the map upon main search button on mobile
     */
    jQuery('.js-mobile-map-search-button').on('click', evt => {
      jQuery(evt.currentTarget).toggleClass('active');
      jQuery('.js-rental-stores-search-form').toggleClass('RentalStores-searchFormWrapper--overlayShown');
      jQuery('.RentalStores').toggleClass('RentalStores--showingOverlay');
    });
    /**
     * 4. Identifying the general layout mode according to the current tab shown
     */
    jQuery('.js-map-and-articles-main-nav-buttons').on('shown.bs.tab', evt => {
      const newClass = evt.target.attributes['aria-controls'].value;
      jQuery('.MapAndArticles')
        .addClass(newClass)
        .removeClass(newClass !== 'rental-stores' ? 'rental-stores' : 'articles-list');
    });
    /**
     * 5. Syncing the search input fields up
     */
    jQuery('.js-typeahead').on('typeahead:select', (evt, suggestion) => {
      jQuery(`.js-typeahead[name='${evt.currentTarget.attributes.name.value}']`).not(evt.currentTarget).val(suggestion.name ? suggestion.name : suggestion);
    });
  },
  initSlick() {
    const $results = jQuery('.RentalStores-resultsList').slick({
      arrows: false,
      autoplay: false,
      mobileFirst: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 5,
            vertical: true,
            verticalSwiping: true,
          },
        },
        {
          breakpoint: 375,
          settings: {
            centerMode: true,
            slidesToScroll: 1,
            slidesToShow: 2,
            swipe: true,
            variableWidth: true,
          },
        },
        {
          breakpoint: 1,
          settings: {
            centerMode: true,
            centerPadding: '10px',
            slidesToScroll: 1,
            slidesToShow: 1,
            swipe: true,
            variableWidth: true,
          },
        },
      ],
    });

    $results.on('wheel', (event) => {
      event.preventDefault();

      if (event.originalEvent.deltaY < 0) {
        $results.slick('slickNext');
      } else {
        $results.slick('slickPrev');
      }
    });
  },
  renderNewListElement(store) {
    const distance = parseFloat(store[0].Value);

    return `
    <div>
      <li class="card RentalStores-resultItem js-rental-stores">
        <h4 class="card-header RentalStores-resultTitle">
          <span class="text-truncate RentalStores-resultTitle--name">${store[2].Value}</span>
          <span class="RentalStores-resultTitle--distance"><strong>${distance.toFixed(2)}</strong> Miles</span>
        </h4>
        <div class="card-body RentalStores-resultInfoWrapper">
          <p class="card-text">
            <span class="RentalStores-resultAddress">${store[3].Value}</span>
            <span class="card-text RentalStores-resultPhone">
              <i></i>
              <a href="tel:${store[7].Value}">${store[7].Value}</a>
            </span>
          </p>
        </div>
        <div class="card-footer RentalStores-resultLinksWrapper">
          <ul></ul>
          <a target="_blank" rel="noopener noreferrer" href="${store[8].Value}" class="text-capitalize CallToAction CallToAction--links">
            Visit website <i class="chevron-right"></i>
          </a>
        </div>
      </li>
    </div>`;
  },
  updateRentalStoresLists(store, marker) {
    const list = document.querySelector('.RentalStores-resultsList');

    const divStore = document.createElement('div');
    const element = this.renderNewListElement(store);

    divStore.innerHTML += element;

    divStore.addEventListener('click', () => {
      window.markers.forEach((markerToChange) => {
        markerToChange.setIcon('https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png');
      });

      marker.setIcon('http://maps.google.com/mapfiles/ms/icons/blue-dot.png');
      window.map.setCenter(marker.getPosition());
    });

    list.appendChild(divStore);
    list.className = 'RentalStores-resultsList';
  },
  getMapData(pos, preId) {
    const crd = pos.coords;
    let id = preId;

    const docID = document.querySelector('.TypeAhead-resultItem.TypeAhead-resultItem--selectable');

    if (id === null) {
      id = docID;
      id = id === null ? '0' : id.dataset.uid;
    }

    $.ajax({
      type: 'POST',
      url: window.admin_url.ajax,
      dataType: 'json',
      data: {
        action: 'get_map_data',
        productID: id,
        lat: crd.latitude,
        lon: crd.longitude,
      },
      error(error) {
        console.error(error);
      },
      success: (response) => {
        const { data: preData } = response;
        const data = JSON.parse(preData);

        if (data[0][0].Key === 'ERROR' && data[0][0].Value === 'CAPTCHA_REQUIRED') {
          $('#recaptcha-modal').modal('show');
          return;
        } else if (data[0][0].Key === 'ERROR') {
          alert(data[0][0].Value);
          return;
        }

        const list = document.querySelector('.RentalStores-resultsList');

        while (list.firstChild) {
          list.removeChild(list.firstChild);
        }

        // Clean all markers
        window.markers.forEach((mark) => {
          mark.setMap(null);
        });
        window.markers = [];

        data.sort((a, b) => parseFloat(a[0].Value).toFixed(2) - parseFloat(b[0].Value).toFixed(2))

        data.forEach((val) => {
          const contentString = `\
          <div id="content">
            <div id="siteNotice">
            </div>
            <h6 id="firstHeading" class="firstHeading">${val[2].Value}</h6>
            <div id="bodyContent">
              <ul>
                <li><b>Address:</b> ${val[3].Value}</li>
                <li><b>Phone:</b> ${val[7].Value}</li>
                <li>
                  <b>Website:</b> <a href="${val[8].Value}">${val[8].Value}</a>
                </li>
              </ul>
            </div>
          </div>\
          `;

          const mark = new window.google.maps.LatLng(val[9].Value, val[10].Value);

          const infowindow = new window.google.maps.InfoWindow({
            content: contentString,
          });

          const marker = new window.google.maps.Marker({
            position: mark,
            map: window.map,
            animation: window.google.maps.Animation.DROP,
            title: val[2].Value,
          });

          marker.addListener('click', function() {
            infowindow.open(window.map, marker);
          });

          this.updateRentalStoresLists(val, marker);

          window.markers.push(marker);
        });

        const bounds = new window.google.maps.LatLngBounds();
        window.markers.forEach((marker) => {
          bounds.extend(marker.getPosition());
        });

        window.map.fitBounds(bounds);

        document.querySelector('span[name="total-stores"]').textContent = data.length;
        this.initSlick();
      },
    });
  },
  geocodeAddress(addr, id) {
    let coords;

    if (addr === null) {
      var place = window.autocomplete.getPlace() === undefined
        ? window.autocomplete2.getPlace()
        : window.autocomplete.getPlace();

      if (place === undefined) {
        return;
      }

      if (!place.geometry) {
        console.log('Returned place contains no geometry');
        return;
      }

      coords = {
        coords: {
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        },
      }
    } else {
      coords = { coords: addr };
    }

    this.getMapData(coords, id);
  },
  finalize() {
    jQuery(($) => {
      $(document).ready(() => {
        const lat = $('input[name=search-rental-lat]').get(0).value;
        const lng = $('input[name=search-rental-lng]').get(0).value;
        const id = $('input[name=search-rental-id]').get(0).value;

        if (lat !== '' || id !== '' || lng !== '') {
          const zoneInput = $('.predective-input');
          const categoryInput = $('input[name=search-rental-category]');

          zoneInput.get(0).value = $('input[name=post-search-rental-zone]').get(0).value;
          zoneInput.get(1).value = $('input[name=post-search-rental-zone]').get(0).value;

          categoryInput.get(0).value = $('input[name=post-search-rental-category]').get(0).value;
          categoryInput.get(1).value = $('input[name=post-search-rental-category]').get(0).value;

          const coords = {
            latitude: lat,
            longitude: lng,
          };

          this.geocodeAddress(coords, id);
        }

        $('.SearchHero-searchButton[type="button"]').on('click', () => {
          const predictiveInput = $('.predective-input');
          const inputOneValue = predictiveInput.get(0).value;
          const inputTwoValue = predictiveInput.get(1).value;

          if (inputOneValue === '' && inputTwoValue === '') {
            alert('Please, enter a place to search');
            return;
          }

          this.geocodeAddress(null, null);
        });
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/map-and-articles.js